export var FieldValidationError;
(function (FieldValidationError) {
    FieldValidationError["Required"] = "Required";
    FieldValidationError["Format"] = "Format";
    FieldValidationError["Length"] = "Length";
    FieldValidationError["MinAge"] = "MinAge";
})(FieldValidationError || (FieldValidationError = {}));
